import { useCallback, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getCompletedInterviews } from "../../application/services/studentDashboard";
import { setCompletedInterviews, appendCompletedInterviews } from "../../store/studentPageReducer";

const useCompletedInterviews = () => {
  const dispatch = useDispatch();
  const { completedInterviews } = useSelector((state) => state.studentpage);
  const { user } = useSelector((state) => state.login.student);
  const email = user?.email || "";

  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [loading, setLoading] = useState(false);
  const loadingRef = useRef(false);

  const fetchCompletedInterviews = useCallback(
    async (pageNum = 1, append = false) => {
      if (loadingRef.current || !email) {
        return;
      }
      
      loadingRef.current = true;
      setLoading(true);

      try {
        const response = await getCompletedInterviews(email, pageNum, 5);
        
        const responseData = response?.data?.data || response?.data || [];
        const pagination = response?.data?.pagination || response?.pagination || {};
        const currentPage = pagination.page || pageNum;
        const limit = pagination.limit || 5;
        const total = pagination.total || 0;

        if (append) {
          dispatch(appendCompletedInterviews(responseData));
        } else {
          dispatch(setCompletedInterviews(responseData));
        }

        const totalPages = Math.ceil(total / limit);
        const hasMorePages = currentPage < totalPages;
        
        setHasMore(hasMorePages);
      } catch (error) {
        console.error("Error fetching completed interviews:", error);
        setHasMore(false);
      } finally {
        loadingRef.current = false;
        setLoading(false);
      }
    },
    [dispatch, email]
  );

  const loadMore = useCallback(() => {
    if (hasMore && !loadingRef.current) {
      const nextPage = page + 1;
      setPage(nextPage);
      fetchCompletedInterviews(nextPage, true);
    }
  }, [hasMore, page, fetchCompletedInterviews]);

  return { 
    completedInterviews, 
    loadMore, 
    hasMore, 
    loading, 
    fetchCompletedInterviews 
  };
};

export default useCompletedInterviews;

